import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminUserActions.js'

const initialState = {
  groups: [],
  groupSelected: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case actions.GROUP_LIST: {
      let r = action.restCall.result

      if (r && r.length > 0) {
        r = r.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }

          if (b.name < a.name) {
            return 1
          }

          return 0
        })
      } else {
        r = []
      }

      console.log(action)

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          groups: r
        }
      }

      return state
    }

    case actions.GROUP_REMOVE_OWNER:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          groups: [
            ...state.groups.map(g => {
              if (g.id != action.removal.groupId) {
                return g
              }

              return {
                ...g,
                owners: g.owners.filter(g => g.id != action.removal.userId)
              }
            })
          ]
        }
      }

      return state

    case actions.GROUP_REMOVE_MEMBER:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          groups: [
            ...state.groups.map(g => {
              if (g.id != action.removal.groupId) {
                return g
              }

              return {
                ...g,
                members: g.members.filter(g => g.id != action.removal.userId)
              }
            })
          ]
        }
      }

      return state

    case actions.GROUP_TOGGLE_EDIT:
      return {
        ...state,
        groupSelected: action.group
      }

    case actions.GROUP_TITLE_CHANGE:
      return {
        ...state,
        groupSelected: {
          ...state.groupSelected,
          [action.field]: action.value
        }
      }

    case actions.GROUP_TITLE_UPDATE:
      console.log(action.restCall)

      return {
        ...state,
        groups: [
          ...state.groups.filter(g => g.id != state.groupSelected.id),
          state.groupSelected
        ].sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }

          if (b.name < a.name) {
            return 1
          }

          return 0
        }),
        groupSelected: null
      }

    case actions.GROUP_DELETE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          groups: state.groups.filter(g => g.id != action.removal.groupId)
        }
      }

      return state

    case actions.DISMISS_GROUP_LIST: {
      return {
        ...state,
        groups: []
      }
    }

    default:
      return state
  }
}

export default reducers
